import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge only knows Tailwind's stock theme; teach it the token names
 * so that, for example, `text-sm` and `text-cta-text` are not seen as the
 * same group and silently dropped.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      color: [
        'bg',
        'surface',
        'border',
        'text',
        'text-muted',
        'link',
        'brand',
        'brand-strong',
        'cta-bg',
        'cta-text',
        'cta-hover',
        'action-bg',
        'action-text',
        'success',
        'warning',
        'danger',
        'focus',
        'surface-brand',
        'on-brand',
        'surface-chrome',
        'surface-pane',
        'surface-pane-strong',
        'surface-overlay',
        'surface-well',
        'rule',
        'glass-edge',
        'scrim',
        (value: string) => value.startsWith('mz-'),
      ],
      spacing: ['touch'],
      radius: ['sm', 'md', 'lg', 'pill', 'none', 'control', 'card', 'panel'],
      shadow: [
        'sm',
        'md',
        'none',
        'card',
        'hairline',
        'float',
        'pane',
        'overlay',
        'action',
        'chosen',
      ],
      text: ['xs', 'sm', 'base', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl'],
      'font-weight': ['light', 'regular', 'medium', 'bold'],
      leading: ['body', 'heading', 'display'],
      container: ['site'],
    },
  },
})

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
